import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-15bcac7a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "timestamp-container"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "card-header"
}, [/*#__PURE__*/_createElementVNode("span", null, "时间戳转换工具")], -1));
const _hoisted_3 = {
  class: "current-time-section"
};
const _hoisted_4 = {
  class: "time-display"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "time-label"
}, "当前时间戳", -1));
const _hoisted_6 = {
  class: "time-value"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "time-unit"
}, "秒", -1));
const _hoisted_8 = {
  class: "convert-section"
};
const _hoisted_9 = {
  class: "section-title"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "时间戳转时间", -1));
const _hoisted_11 = {
  class: "input-group"
};
const _hoisted_12 = {
  class: "action-result"
};
const _hoisted_13 = {
  class: "result-box"
};
const _hoisted_14 = {
  key: 0,
  class: "result-value"
};
const _hoisted_15 = {
  key: 1,
  class: "placeholder-text"
};
const _hoisted_16 = {
  class: "convert-section"
};
const _hoisted_17 = {
  class: "section-title"
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "时间转时间戳", -1));
const _hoisted_19 = {
  class: "input-group"
};
const _hoisted_20 = {
  class: "action-result"
};
const _hoisted_21 = {
  class: "result-box"
};
const _hoisted_22 = {
  class: "result-with-unit"
};
const _hoisted_23 = {
  class: "result-value"
};
const _hoisted_24 = {
  key: 1,
  class: "placeholder-text"
};
const _hoisted_25 = {
  class: "convert-section"
};
const _hoisted_26 = {
  class: "section-title"
};
const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "未来时间计算", -1));
const _hoisted_28 = {
  class: "input-group"
};
const _hoisted_29 = {
  class: "action-result"
};
const _hoisted_30 = {
  class: "result-box"
};
const _hoisted_31 = {
  class: "result-with-unit"
};
const _hoisted_32 = {
  class: "result-value"
};
const _hoisted_33 = {
  key: 1,
  class: "placeholder-text"
};
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { Timer, Calendar, ArrowRight, Stopwatch } from '@element-plus/icons-vue';

// 实时更新当前时间戳（秒）

export default {
  __name: 'TimeChange',
  setup(__props) {
    const nowTimestamp = ref(Math.floor(Date.now() / 1000));
    const timerRunning = ref(true);
    let timer = null;
    const startTimer = () => {
      if (!timer) {
        timer = setInterval(() => {
          nowTimestamp.value = Math.floor(Date.now() / 1000);
        }, 1000);
      }
    };
    const stopTimer = () => {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    };
    const toggleTimerUpdate = () => {
      timerRunning.value = !timerRunning.value;
      if (timerRunning.value) {
        startTimer();
      } else {
        stopTimer();
      }
    };
    onMounted(() => {
      startTimer();
    });
    onBeforeUnmount(() => {
      stopTimer();
    });
    const timestampInput = ref('');
    const timestampUnit = ref('s');
    const convertedTime = ref('');
    const timeInput = ref('');
    const timestampOutput = ref('');
    const outputUnit = ref('s');
    const currentTimeInput = ref(0);
    const timeUnit = ref('month');
    const calculatedResult = ref('');
    const resultUnit = ref('s');

    // 时间戳转时间
    const convertTimestampToTime = () => {
      const input = parseInt(timestampInput.value);
      if (isNaN(input) || input <= 0) {
        convertedTime.value = '输入无效';
        return;
      }
      try {
        const ms = timestampUnit.value === 's' ? input * 1000 : input;
        const date = new Date(ms);
        if (isNaN(date.getTime())) {
          throw new Error('时间戳无效');
        }

        // 格式化日期为 YYYY-MM-DD HH:MM:SS
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
        convertedTime.value = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      } catch (error) {
        convertedTime.value = error.message || '转换失败';
      }
    };

    // 时间转时间戳
    const convertTimeToTimestamp = () => {
      if (!timeInput.value.trim()) {
        timestampOutput.value = '请输入时间';
        return;
      }
      try {
        const date = new Date(timeInput.value);
        if (isNaN(date.getTime())) {
          throw new Error('时间格式错误');
        }
        let timestamp = date.getTime();
        if (outputUnit.value === 's') {
          timestamp = Math.floor(timestamp / 1000);
        }
        timestampOutput.value = timestamp.toString();
      } catch (error) {
        timestampOutput.value = error.message || '时间格式错误';
      }
    };

    // 计算当前时间
    const calculateTime = () => {
      const current = new Date();
      const inputValue = parseInt(currentTimeInput.value) || 0;
      if (timeUnit.value === 'month') {
        current.setMonth(current.getMonth() + inputValue);
      } else if (timeUnit.value === 'day') {
        current.setDate(current.getDate() + inputValue);
      } else if (timeUnit.value === 'hour') {
        current.setHours(current.getHours() + inputValue);
      }
      let result = current.getTime();
      if (resultUnit.value === 's') {
        result = Math.floor(result / 1000);
      }
      calculatedResult.value = result.toString();
    };
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_divider = _resolveComponent("el-divider");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_input_number = _resolveComponent("el-input-number");
      const _component_el_card = _resolveComponent("el-card");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_card, {
        class: "timestamp-card"
      }, {
        header: _withCtx(() => [_hoisted_2]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("div", _hoisted_6, [_createTextVNode(_toDisplayString(nowTimestamp.value), 1), _hoisted_7])]), _createVNode(_component_el_button, {
          type: timerRunning.value ? 'danger' : 'success',
          onClick: toggleTimerUpdate,
          class: "control-button"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(timerRunning.value ? '停止' : '恢复'), 1)]),
          _: 1
        }, 8, ["type"])]), _createVNode(_component_el_divider, {
          "content-position": "center"
        }, {
          default: _withCtx(() => [_createTextVNode("时间转换")]),
          _: 1
        }), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_unref(Timer))]),
          _: 1
        }), _hoisted_10]), _createElementVNode("div", _hoisted_11, [_createVNode(_component_el_input, {
          modelValue: timestampInput.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => timestampInput.value = $event),
          placeholder: "输入时间戳",
          class: "input-field",
          clearable: ""
        }, {
          prepend: _withCtx(() => [_createTextVNode("时间戳")]),
          _: 1
        }, 8, ["modelValue"]), _createVNode(_component_el_select, {
          modelValue: timestampUnit.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => timestampUnit.value = $event),
          class: "unit-select"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_option, {
            label: "秒(s)",
            value: "s"
          }), _createVNode(_component_el_option, {
            label: "毫秒(ms)",
            value: "ms"
          })]),
          _: 1
        }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_12, [_createVNode(_component_el_button, {
          onClick: convertTimestampToTime,
          type: "primary",
          class: "action-button",
          icon: _unref(ArrowRight)
        }, {
          default: _withCtx(() => [_createTextVNode(" 转换 ")]),
          _: 1
        }, 8, ["icon"]), _createElementVNode("div", _hoisted_13, [convertedTime.value ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(convertedTime.value), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_15, "转换结果将显示在这里"))])])]), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_unref(Calendar))]),
          _: 1
        }), _hoisted_18]), _createElementVNode("div", _hoisted_19, [_createVNode(_component_el_input, {
          modelValue: timeInput.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => timeInput.value = $event),
          placeholder: "如: 2025-04-08 17:58:08",
          class: "input-field",
          clearable: ""
        }, {
          prepend: _withCtx(() => [_createTextVNode("时间")]),
          _: 1
        }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_20, [_createVNode(_component_el_button, {
          onClick: convertTimeToTimestamp,
          type: "primary",
          class: "action-button",
          icon: _unref(ArrowRight)
        }, {
          default: _withCtx(() => [_createTextVNode(" 转换 ")]),
          _: 1
        }, 8, ["icon"]), _createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [timestampOutput.value ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createElementVNode("span", _hoisted_23, _toDisplayString(timestampOutput.value), 1), _createVNode(_component_el_select, {
          modelValue: outputUnit.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => outputUnit.value = $event),
          class: "unit-select-small"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_option, {
            label: "秒(s)",
            value: "s"
          }), _createVNode(_component_el_option, {
            label: "毫秒(ms)",
            value: "ms"
          })]),
          _: 1
        }, 8, ["modelValue"])], 64)) : (_openBlock(), _createElementBlock("span", _hoisted_24, "转换结果将显示在这里"))])])])]), _createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_unref(Stopwatch))]),
          _: 1
        }), _hoisted_27]), _createElementVNode("div", _hoisted_28, [_createVNode(_component_el_input_number, {
          modelValue: currentTimeInput.value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => currentTimeInput.value = $event),
          min: 0,
          "controls-position": "right",
          class: "number-input"
        }, null, 8, ["modelValue"]), _createVNode(_component_el_select, {
          modelValue: timeUnit.value,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => timeUnit.value = $event),
          class: "unit-select"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_option, {
            label: "月后",
            value: "month"
          }), _createVNode(_component_el_option, {
            label: "天后",
            value: "day"
          }), _createVNode(_component_el_option, {
            label: "小时后",
            value: "hour"
          })]),
          _: 1
        }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_29, [_createVNode(_component_el_button, {
          onClick: calculateTime,
          type: "primary",
          class: "action-button",
          icon: _unref(ArrowRight)
        }, {
          default: _withCtx(() => [_createTextVNode(" 计算 ")]),
          _: 1
        }, 8, ["icon"]), _createElementVNode("div", _hoisted_30, [_createElementVNode("div", _hoisted_31, [calculatedResult.value ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createElementVNode("span", _hoisted_32, _toDisplayString(calculatedResult.value), 1), _createVNode(_component_el_select, {
          modelValue: resultUnit.value,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => resultUnit.value = $event),
          class: "unit-select-small"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_option, {
            label: "秒(s)",
            value: "s"
          }), _createVNode(_component_el_option, {
            label: "毫秒(ms)",
            value: "ms"
          })]),
          _: 1
        }, 8, ["modelValue"])], 64)) : (_openBlock(), _createElementBlock("span", _hoisted_33, "计算结果将显示在这里"))])])])])]),
        _: 1
      })]);
    };
  }
};